import BillingReturn from "@/services/billing/billing-return.js";

const state = {
    returnDetails: null,
    fullDetails: null,
    isLoading: false,
    isEditMode: false,
    itemCount: 0
};

const getters = {
    returnDetails: state => {
        return state.returnDetails;
    },
    fullDetails: state => {
        return state.fullDetails;
    },
    isLoading: state => {
        return state.isLoading;
    },
    isEditMode: state => {
        return state.isEditMode;
    },
    itemCount: state => {
        return state.itemCount;
    }
};

const actions = {
    async getReturnDetails({ commit }, returnId) {
        commit("setLoading", true);

        return BillingReturn.getReturn(returnId, true)
            .then(response => {
                //if 200
                if (response.code == 200) {
                    commit("setReturnDetails", response.resources);
                    return true;
                }

                return false;
                // commit("setPermissions", response.permissions);
            })
            .catch(error => error.data)
            .finally(() => commit("setLoading", false));
    }
};

const mutations = {
    setReturnDetails(state, returnDetails) {
        state.fullDetails = returnDetails;
        state.returnDetails = returnDetails.return;
    },
    setLoading(state, isLoading) {
        state.isLoading = isLoading;
    },
    setEditMode(state, isEditMode) {
        state.isEditMode = isEditMode;
    },
    setItemCount(state, itemCount) {
        state.itemCount = itemCount;
    },
    clearReturnDetails(state) {
        state.fullDetails = null;
        state.returnDetails = null;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
